/*12039580: THis is the Most Important file to Show the Left Collection Side Bar*/


(function () {
  /*
   * ============================================================
   * CONFIGURATION
   * ============================================================
   *
   * This is a deliberately different architecture from
   * multi-collection-infinite-scroll.js - not a variant of it, a
   * different concept entirely. The sidebar looks and behaves the
   * same, but there is no continuous multi-collection feed and no
   * scroll-triggered pagination at all. Clicking a category
   * replaces the entire product area with just that collection,
   * which then loads its full product set automatically in the
   * background (page after page, not tied to scroll position) until
   * done. If the customer clicks a different category before that
   * finishes, whatever was still loading is abandoned immediately.
   *
   * Because only one collection's cards ever exist in the DOM at
   * once (the previous one is fully cleared away, not kept around),
   * there's no need for the image-batch memory system, shelving, or
   * any of the multi-section scroll-safety work the other file
   * needed - a real simplification, not just a smaller version of
   * the same thing.
   */

  const GRID_SELECTOR = '#product-grid';
  const TITLE_SELECTOR = '.collection-hero__title';
  const MAX_PAGES_PER_COLLECTION = 200;


  /*
   * ============================================================
   * COLLECTION METAFIELDS (priority order, image, short name)
   * ============================================================
   *
   * Identical to the other file - read from a JSON blob a Liquid
   * snippet embeds on the page (see quick-collection-metafields.liquid).
   */

  function loadCollectionMetafields() {
    const map = new Map();

    const scriptEl = document.getElementById('quick-collection-metafields');

    if (!scriptEl) {
      console.warn(
        '[single-view] #quick-collection-metafields script tag not found - ' +
          'using default order/images/names.'
      );
      return map;
    }

    let entries;

    try {
      entries = JSON.parse(scriptEl.textContent);
    } catch (error) {
      console.error(
        '[single-view] Failed to parse #quick-collection-metafields JSON - ' +
          'using default order/images/names.',
        error
      );
      return map;
    }

    if (!Array.isArray(entries)) {
      console.error(
        '[single-view] #quick-collection-metafields JSON was not an array - ' +
          'using default order/images/names.'
      );
      return map;
    }

    entries.forEach((entry) => {
      if (!entry || typeof entry.handle !== 'string') return;

      map.set(entry.handle, {
        priority: entry.priority,
        image: typeof entry.image === 'string' && entry.image.trim() !== '' ? entry.image : null,
        shortName:
          typeof entry.shortName === 'string' && entry.shortName.trim() !== ''
            ? entry.shortName.trim()
            : null
      });
    });

    console.log('[single-view] Loaded metafields for', map.size, 'collection(s).');

    return map;
  }

  const collectionMetafields = loadCollectionMetafields();

  function getCollectionPriority(handle) {
    const meta = collectionMetafields.get(handle);

    if (!meta || meta.priority === null || meta.priority === undefined) {
      return Infinity;
    }

    const numericPriority = Number(meta.priority);
    return Number.isFinite(numericPriority) ? numericPriority : Infinity;
  }

  function getCollectionImageUrl(handle) {
    const meta = collectionMetafields.get(handle);
    return meta ? meta.image : null;
  }

  function getCollectionShortName(handle) {
    const meta = collectionMetafields.get(handle);
    return meta ? meta.shortName : null;
  }

  /*
   * Set this to force the active-sidebar-state color exactly.
   * Format: comma-separated R, G, B - e.g. '221, 29, 29' for red.
   * Leave as null to auto-detect from the theme's own CSS variables.
   */
  const MANUAL_ACCENT_RGB = '144, 161, 125'; // #90A17D


  /*
   * ============================================================
   * FIND THE ORIGINAL SHOPIFY GRID + TITLE
   * ============================================================
   *
   * Both are reused directly for every collection shown, rather
   * than creating a new grid/title per collection - there's only
   * ever one of each on the page in this architecture, so their
   * content just gets replaced in place.
   */

  const originalGrid = document.querySelector(GRID_SELECTOR);

  if (!originalGrid) {
    console.log('[single-view] No product grid found.');
    return;
  }

  const originalTitle = document.querySelector(TITLE_SELECTOR);


  /*
   * ============================================================
   * MEASURE THE THEME'S OWN PAGE EDGE PADDING
   * ============================================================
   */

  function measurePageEdgeInset() {
    let node = originalGrid.parentElement;
    let inset = 0;

    while (node && node !== document.body) {
      const paddingLeft = parseFloat(getComputedStyle(node).paddingLeft) || 0;

      if (paddingLeft > 0) {
        inset = paddingLeft;
        break;
      }

      node = node.parentElement;
    }

    document.documentElement.style.setProperty('--sv-page-inset', `${inset}px`);
  }

  measurePageEdgeInset();


  /*
   * ============================================================
   * CSS
   * ============================================================
   */

  const style = document.createElement('style');

  style.textContent = `
    .sv-layout {
      display: flex;
      align-items: flex-start;
      width: calc(100% + var(--sv-page-inset, 0px));
      margin-left: calc(-1 * var(--sv-page-inset, 0px));
    }

    .sv-sidebar {
      position: sticky;
      top: var(--sv-header-height, 0px);
      max-height: calc(100vh - var(--sv-header-height, 0px));
      overflow-y: auto;
      flex: 0 0 72px;
      width: 72px;
      box-sizing: border-box;
      border-right: 1px solid rgba(0, 0, 0, 0.08);
      background-color: #ffffff;
      -ms-overflow-style: none;
      scrollbar-width: none;
      overscroll-behavior: contain;
      touch-action: pan-y;
      scroll-behavior: smooth;
    }

    .sv-sidebar::-webkit-scrollbar {
      display: none;
    }

    .sv-nav-list {
      display: flex;
      flex-direction: column;
      gap: 6px;
      padding-bottom: 45vh;
    }

    .sv-nav-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 5px;
      padding: 14px 6px;
      border: none;
      background: none;
      cursor: pointer;
      font-family: inherit;
      text-align: center;
      width: calc(100% - 8px);
      margin-left: 4px;
      margin-right: 4px;
      box-sizing: border-box;
      border-radius: 10px;
      transition: background-color 180ms ease;
      position: relative;
    }

    .sv-nav-item:active {
      transform: scale(0.97);
      transition: transform 100ms ease;
    }

    .sv-nav-item__image-wrapper {
      position: relative;
      width: 40px;
      height: 40px;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(0, 0, 0, 0.05);
      flex-shrink: 0;
      transition: transform 180ms ease;
    }

    .sv-nav-item__image-wrapper--fallback {
      font-size: 14px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.4);
    }

    .sv-nav-item__image {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .sv-nav-item__label {
      font-size: 9px;
      font-weight: 600;
      line-height: 1.3;
      color: #000000;
      transition: color 180ms ease;
      width: 100%;
      padding: 0 3px;
      box-sizing: border-box;
      hyphens: auto;
      -webkit-hyphens: auto;
      overflow-wrap: break-word;
      word-break: break-word;
    }

    .sv-nav-item--active {
      background: linear-gradient(
        to top,
        rgb(var(--sv-accent-rgb, 26, 26, 26)) 0%,
        #ffffff 100%
      );
    }

    .sv-nav-item--active .sv-nav-item__image-wrapper {
      transform: scale(1.06);
    }

    .sv-nav-item--active .sv-nav-item__label {
      color: #ffffff;
    }


    #sv-content {
      flex: 1 1 auto;
      min-width: 0;
      padding-left: var(--sv-page-inset, 0px);
      box-sizing: border-box;
    }

    /*
     * Centered placeholder shown the moment a click clears the grid,
     * until that collection's first page has actually rendered.
     * Not a grid child - the theme's own grid layout CSS (column
     * counts, gaps sized for product cards) would otherwise apply
     * to it too and it would look out of place.
     */
    .sv-loading-state {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 15vh 20px;
      box-sizing: border-box;
    }

    .sv-loading-state[hidden] {
      display: none;
    }

    /*
     * Shown at the bottom of the grid while pages 2+ of the current
     * collection are still being fetched automatically in the
     * background - lets the customer know more is genuinely still
     * coming, without needing to scroll to ask for it.
     */
    .sv-loading-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 32px 20px;
      box-sizing: border-box;
    }

    .sv-loading-footer[hidden] {
      display: none;
    }

    /*
     * Shown once a collection has genuinely finished loading
     * everything it has - since there's no auto-advance to a next
     * collection in this architecture (unlike the continuous-feed
     * version), reaching the end could otherwise feel like a dead
     * end. A one-time entrance fade, not a continuous animation -
     * a looping motion reads as "still working on something",
     * which is the opposite of what this needs to communicate.
     */
    .sv-end-of-collection {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 14px;
      width: 100%;
      padding: 24px 20px 140px;
      box-sizing: border-box;
      text-align: center;
      animation: sv-fade-in 400ms ease-out both;
    }

    .sv-end-of-collection[hidden] {
      display: none;
    }

    .sv-end-of-collection__title {
      font-size: 15px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
    }

    /*
     * Overrides the theme's own .button color specifically for
     * this button - !important is needed since the theme's own
     * button styling would otherwise take precedence over a plain
     * class rule of the same specificity.
     */
    .sv-load-next-btn {
      background-color: #90A17D !important;
      border-color: #90A17D !important;
      color: #ffffff !important;
    }

    @media (prefers-reduced-motion: reduce) {
      .sv-end-of-collection {
        animation: none;
      }
    }

    /*
     * Directly neutralizes the exact padding rule found via direct
     * inspection of the theme's own stylesheet (a Dawn-generated
     * "section padding" rule, 27px top and bottom, tied to this
     * specific section's numeric ID). This is a plain CSS override,
     * not JS-based detection - it doesn't depend on correctly
     * identifying whether the element is "empty" or on any script
     * timing, so it should work regardless of why the previous
     * attempts weren't fully resolving this. Matches on the class
     * substring rather than the full name, since the numeric
     * section ID prefix is specific to this store and would differ
     * on any other site using this same file.
     */
    [class*="__product-grid-padding"] {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }

    .sv-image-unloaded {
      background-color: rgba(0, 0, 0, 0.045);
    }

    /*
     * Shimmer while an image is still loading for the first time -
     * text/price render instantly (no network needed), the image
     * itself can genuinely lag behind. color:transparent + font-
     * size:0 stop the browser's native alt-text-while-unloaded
     * rendering; the alt attribute itself is untouched for screen
     * readers.
     */
    .sv-image-loading-in {
      background: linear-gradient(
        100deg,
        rgba(0, 0, 0, 0.04) 30%,
        rgba(0, 0, 0, 0.09) 45%,
        rgba(0, 0, 0, 0.04) 60%
      );
      background-size: 250% 100%;
      animation: sv-shimmer 1.6s ease-in-out infinite;
      color: transparent;
      font-size: 0;
    }

    .sv-image-loading-in.is-loaded {
      animation: none;
      background: none;
    }

    .sv-image-loading-in.is-failed {
      animation: none;
      background: rgba(0, 0, 0, 0.06);
      color: initial;
      font-size: initial;
    }

    @keyframes sv-shimmer {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }

    .sv-card-fade-in {
      animation: sv-fade-in 240ms ease-out both;
    }

    @keyframes sv-fade-in {
      from { opacity: 0; transform: translateY(6px); }
      to { opacity: 1; transform: translateY(0); }
    }

    @media (prefers-reduced-motion: reduce) {
      .sv-image-loading-in,
      .sv-card-fade-in {
        animation: none;
      }

      .sv-image-loading-in {
        background: rgba(0, 0, 0, 0.06);
      }
    }
  `;

  document.head.appendChild(style);


  /*
   * ============================================================
   * DETECT SHOPIFY STICKY HEADER HEIGHT
   * ============================================================
   */

  function updateStickyHeaderHeight() {
    const header =
      document.querySelector('sticky-header') ||
      document.querySelector('.header-wrapper') ||
      document.querySelector('#shopify-section-header');

    if (!header) {
      document.documentElement.style.setProperty('--sv-header-height', '0px');
      return;
    }

    const headerRect = header.getBoundingClientRect();
    const headerStyle = window.getComputedStyle(header);

    const isSticky = headerStyle.position === 'sticky' || headerStyle.position === 'fixed';

    const headerParent = header.parentElement;
    let parentIsSticky = false;

    if (headerParent) {
      const parentStyle = window.getComputedStyle(headerParent);
      parentIsSticky = parentStyle.position === 'sticky' || parentStyle.position === 'fixed';
    }

    const headerIsVisible = headerRect.bottom > 0 && headerRect.top < window.innerHeight;

    const headerHeight =
      (isSticky || parentIsSticky) && headerIsVisible ? Math.max(0, headerRect.bottom) : 0;

    document.documentElement.style.setProperty(
      '--sv-header-height',
      `${Math.round(headerHeight)}px`
    );
  }

  updateStickyHeaderHeight();

  const headerResizeObserver =
    typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(() => updateStickyHeaderHeight())
      : null;

  const detectedHeader =
    document.querySelector('sticky-header') ||
    document.querySelector('.header-wrapper') ||
    document.querySelector('#shopify-section-header');

  if (headerResizeObserver && detectedHeader) {
    headerResizeObserver.observe(detectedHeader);
  }

  window.addEventListener('resize', () => {
    updateStickyHeaderHeight();
    measurePageEdgeInset();
  });


  /*
   * ============================================================
   * SHARED STATE
   * ============================================================
   */

  const initialHandle = window.location.pathname
    .split('/collections/')[1]
    ?.split('/')[0]
    ?.split('?')[0];

  let activeHandle = initialHandle;

  /*
   * Incremented on every collection switch. Any in-progress fetch
   * loop checks this after each await and abandons itself the
   * instant it no longer matches - this is the entire cancellation
   * mechanism. Simpler than aborting the underlying fetch() calls,
   * and just as correct: a stale response is simply never used.
   */
  let activeLoadToken = 0;

  /*
   * Full priority-ordered handle list, set once during initialise -
   * this is what "the next category" means for the Load Next
   * Category button shown at the end of a collection.
   */
  let orderedHandles = [];


  /*
   * ============================================================
   * THEME SPINNER
   * ============================================================
   */

  function buildThemeLoadingSpinner() {
    const existingSpinner = document.querySelector('.loading__spinner');

    if (existingSpinner) {
      const clone = existingSpinner.cloneNode(true);
      clone.classList.remove('hidden');
      clone.removeAttribute('hidden');
      return clone;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'loading__spinner';
    wrapper.innerHTML = `
      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    `;
    return wrapper;
  }

  const loadingStateElement = document.createElement('div');
  loadingStateElement.className = 'sv-loading-state';
  loadingStateElement.hidden = true;
  loadingStateElement.appendChild(buildThemeLoadingSpinner());

  const loadingFooterElement = document.createElement('div');
  loadingFooterElement.className = 'sv-loading-footer';
  loadingFooterElement.hidden = true;
  loadingFooterElement.appendChild(buildThemeLoadingSpinner());

  const endOfCollectionElement = document.createElement('div');
  endOfCollectionElement.className = 'sv-end-of-collection';
  endOfCollectionElement.hidden = true;


  /*
   * ============================================================
   * IMAGE LOADING (shimmer while each image loads for the first time)
   * ============================================================
   *
   * No unload/reload cycle here at all, unlike the other file -
   * with only one collection ever in the DOM at a time, there's
   * nothing to strip images from once they're loaded. Every image
   * just loads once, normally, with a shimmer placeholder while it
   * does.
   */

  function applyImageLoadingTreatment(card) {
    const img = card.querySelector('img');
    if (!img) return;

    img.loading = 'lazy';
    img.decoding = 'async';

    if (img.complete && img.naturalWidth > 0) return; // already loaded, e.g. browser cache

    img.classList.add('sv-image-loading-in');
    img.addEventListener('load', () => img.classList.add('is-loaded'), { once: true });
    img.addEventListener('error', () => img.classList.add('is-failed'), { once: true });
  }


  /*
   * ============================================================
   * CATEGORY SIDEBAR
   * ============================================================
   *
   * Every collection gets a sidebar entry immediately, all at once
   * - there's no background pre-building to wait for in this
   * architecture, so there's no reason to reveal items gradually.
   */

  const sidebarElement = document.createElement('nav');
  sidebarElement.className = 'sv-sidebar';
  sidebarElement.setAttribute('aria-label', 'Collections');

  const sidebarList = document.createElement('div');
  sidebarList.className = 'sv-nav-list';
  sidebarElement.appendChild(sidebarList);

  /*
   * Same momentum-scroll fix as the other file: overscroll-behavior
   * alone is unreliable on iOS for interrupting an in-flight
   * momentum scroll on the main page when a new touch begins on the
   * sidebar. Temporarily locking the body to position:fixed
   * actually removes it from the scrolling context and kills the
   * momentum reliably. Gated by recent-scroll detection so a tap
   * while the page is already stationary costs nothing extra.
   */
  let lastMainScrollEventTime = 0;

  sidebarElement.addEventListener(
    'touchstart',
    () => {
      const recentlyScrolling = Date.now() - lastMainScrollEventTime < 150;
      if (!recentlyScrolling) return;

      const scrollY = window.scrollY;
      const bodyEl = document.body;

      bodyEl.style.position = 'fixed';
      bodyEl.style.top = `-${scrollY}px`;
      bodyEl.style.left = '0';
      bodyEl.style.right = '0';
      bodyEl.style.width = '100%';

      const restore = () => {
        bodyEl.style.position = '';
        bodyEl.style.top = '';
        bodyEl.style.left = '';
        bodyEl.style.right = '';
        bodyEl.style.width = '';
        window.scrollTo(0, scrollY);
      };

      requestAnimationFrame(() => requestAnimationFrame(restore));
    },
    { passive: true }
  );

  let lastKnownScrollY = window.scrollY;

  window.addEventListener(
    'scroll',
    () => {
      const currentScrollY = window.scrollY;

      /*
       * Only counts as "genuinely scrolling" if the position
       * actually moved by a meaningful amount - some browsers fire
       * scroll events when page content grows or shrinks below the
       * viewport (exactly what happens while a large collection's
       * remaining pages load in the background), even though the
       * customer never touched anything and scrollY never actually
       * changed. Without this check, that false signal could make
       * the sidebar think a momentum scroll was recently happening
       * essentially the whole time a big collection was loading,
       * triggering the touchstart body-lock below on every tap and
       * disrupting the click that should have followed it.
       */
      if (Math.abs(currentScrollY - lastKnownScrollY) > 2) {
        lastMainScrollEventTime = Date.now();
      }

      lastKnownScrollY = currentScrollY;
    },
    { passive: true }
  );

  const sidebarItemsByHandle = new Map();
  let activeSidebarItemEl = null;

  function humanizeHandle(handle) {
    return handle
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  function determineAccentRgb() {
    if (MANUAL_ACCENT_RGB) return MANUAL_ACCENT_RGB;

    const candidateVariables = [
      '--color-button',
      '--color-accent-1',
      '--color-accent',
      '--color-primary',
      '--color-link',
      '--color-foreground'
    ];

    for (const variableName of candidateVariables) {
      const value = getComputedStyle(document.documentElement)
        .getPropertyValue(variableName)
        .trim();

      if (value) return value;
    }

    return '26, 26, 26';
  }

  function getSidebarLabelText(handle, titleText) {
    const shortName = getCollectionShortName(handle);
    if (shortName) return shortName;
    return titleText || humanizeHandle(handle);
  }

  function createSidebarItem(handle, titleText) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'sv-nav-item';
    button.dataset.collection = handle;
    button.setAttribute('aria-current', 'false');

    const labelText = getSidebarLabelText(handle, titleText);

    const imageWrapper = document.createElement('span');
    imageWrapper.className = 'sv-nav-item__image-wrapper';

    const imageUrl = getCollectionImageUrl(handle);

    if (imageUrl) {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = '';
      img.loading = 'lazy';
      img.className = 'sv-nav-item__image';
      imageWrapper.appendChild(img);
    } else {
      imageWrapper.classList.add('sv-nav-item__image-wrapper--fallback');
      imageWrapper.textContent = (labelText || handle).charAt(0).toUpperCase();
    }

    const label = document.createElement('span');
    label.className = 'sv-nav-item__label';
    label.textContent = labelText;

    button.appendChild(imageWrapper);
    button.appendChild(label);

    button.addEventListener('click', () => switchToCollection(handle));

    return button;
  }

  function addSidebarItem(handle, titleText) {
    if (sidebarItemsByHandle.has(handle)) return;

    const item = createSidebarItem(handle, titleText);
    sidebarList.appendChild(item);
    sidebarItemsByHandle.set(handle, item);
  }

  function updateSidebarActiveState(handle) {
    const itemEl = sidebarItemsByHandle.get(handle);
    if (!itemEl) return;

    if (activeSidebarItemEl) {
      activeSidebarItemEl.classList.remove('sv-nav-item--active');
      activeSidebarItemEl.setAttribute('aria-current', 'false');
    }

    itemEl.classList.add('sv-nav-item--active');
    itemEl.setAttribute('aria-current', 'true');
    activeSidebarItemEl = itemEl;

    /*
     * Only scrolls the sidebar if the newly active item genuinely
     * isn't visible right now. A direct tap on a sidebar item means
     * it's already visible by definition, so this naturally does
     * nothing extra in that case - but clicking "View More
     * Products" can land on a category several rows down that was
     * never actually in view, which is exactly the case this is
     * for. Smooth scrolling comes from the sidebar's own CSS
     * (scroll-behavior: smooth), triggered just by setting scrollTop.
     */
    const sidebarRect = sidebarElement.getBoundingClientRect();
    const itemRect = itemEl.getBoundingClientRect();

    const isVisible = itemRect.top >= sidebarRect.top && itemRect.bottom <= sidebarRect.bottom;

    if (!isVisible) {
      const itemOffsetWithinSidebar =
        itemRect.top - sidebarRect.top + sidebarElement.scrollTop;

      const desiredScrollTop =
        itemOffsetWithinSidebar - sidebarRect.height / 2 + itemRect.height / 2;

      sidebarElement.scrollTop = Math.max(0, desiredScrollTop);
    }
  }


  /*
   * ============================================================
   * CLEAN COLLECTION TITLE
   * ============================================================
   */

  function getCleanTitle(titleElement) {
    if (!titleElement) return '';

    const clone = titleElement.cloneNode(true);
    clone.querySelectorAll('.visually-hidden').forEach((el) => el.remove());

    return clone.textContent.trim();
  }


  /*
   * ============================================================
   * UNIQUE KEY FOR A PRODUCT CARD (for de-duping)
   * ============================================================
   *
   * Only actually needed for the initial collection's own
   * continuation, in case the theme's native pagination also adds
   * products concurrently - every other collection starts from a
   * cleared grid with nothing to de-dupe against.
   */

  function getProductCardKey(card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;

    const href = link.getAttribute('href');
    if (!href) return null;

    return href.split('?')[0];
  }


  /*
   * ============================================================
   * FETCH HELPERS
   * ============================================================
   */

  async function fetchAllCollections() {
    let page = 1;
    const collections = [];

    while (true) {
      const response = await fetch(`/collections.json?limit=250&page=${page}`);
      if (!response.ok) {
        throw new Error(`Collection list fetch failed: ${response.status}`);
      }

      const data = await response.json();
      const pageCollections = data.collections || [];
      if (pageCollections.length === 0) break;

      collections.push(...pageCollections);
      if (pageCollections.length < 250) break;
      page++;
    }

    return collections;
  }

  async function fetchCollectionPage(handle, page) {
    const url = `/collections/${handle}?page=${page}`;
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Collection fetch failed: ${response.status}`);
    }

    const html = await response.text();
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function getProductCardsFromDocument(doc) {
    const fetchedGrid = doc.querySelector(GRID_SELECTOR);
    if (!fetchedGrid) return [];
    return Array.from(fetchedGrid.querySelectorAll(':scope > li.grid__item'));
  }


  /*
   * ============================================================
   * DETERMINE COLLECTION ORDER (for the sidebar only)
   * ============================================================
   */

  async function getOrderedCollectionHandles() {
    const collections = await fetchAllCollections();
    const allHandles = collections.map((c) => c.handle).filter(Boolean);

    const rest = allHandles
      .filter((handle) => handle !== initialHandle)
      .sort((a, b) => getCollectionPriority(a) - getCollectionPriority(b));

    console.log('[single-view] Collection order:', [initialHandle, ...rest]);

    return [initialHandle, ...rest];
  }


  /*
   * ============================================================
   * SWITCH TO A COLLECTION (the core of this whole concept)
   * ============================================================
   *
   * Clears whatever's currently shown and loads the requested
   * collection from scratch: page 1 first (fast initial paint),
   * then every remaining page automatically afterward, not tied to
   * scroll position at all. If switchToCollection is called again
   * before this finishes - the customer clicking somewhere else -
   * the token check after each await causes this loop to abandon
   * itself silently, without ever touching the DOM again.
   */

  function switchToCollection(handle) {
    if (handle === activeHandle) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const thisToken = ++activeLoadToken;

    activeHandle = handle;
    history.replaceState({}, '', `/collections/${handle}`);

    updateSidebarActiveState(handle);

    // Optimistic title using whatever we already know (short name
    // or a readable version of the handle) - swapped for the real
    // fetched title the instant page 1 arrives, a moment below.
    if (originalTitle) {
      originalTitle.textContent = getSidebarLabelText(handle, null);
    }

    originalGrid.innerHTML = '';
    hideLoadingFooter();
    hideEndOfCollectionHint();
    loadingStateElement.hidden = false;

    window.scrollTo({ top: 0, behavior: 'smooth' });

    loadCollectionFully(handle, thisToken, { isInitial: false });
  }

  function showLoadingFooter() {
    loadingFooterElement.hidden = false;
    if (loadingFooterElement.parentNode !== originalGrid.parentNode) {
      originalGrid.parentNode.insertBefore(loadingFooterElement, originalGrid.nextSibling);
    }
  }

  function hideLoadingFooter() {
    loadingFooterElement.hidden = true;
  }

  function getNextHandleInOrder(handle) {
    const index = orderedHandles.indexOf(handle);
    if (index === -1 || index === orderedHandles.length - 1) return null;
    return orderedHandles[index + 1];
  }

  function showEndOfCollectionHint(handle) {
    endOfCollectionElement.innerHTML = '';

    const nextHandle = getNextHandleInOrder(handle);

    if (nextHandle) {
      const button = document.createElement('button');
      button.type = 'button';
      // Shopify's own default button class for shape/sizing/hover
      // behavior, plus a specific override for this button's color.
      button.className = 'button sv-load-next-btn';
      button.textContent = 'View More Products';
      button.addEventListener('click', () => switchToCollection(nextHandle));
      endOfCollectionElement.appendChild(button);
    } else {
      const title = document.createElement('span');
      title.className = 'sv-end-of-collection__title';
      title.textContent = "You've seen it all!";
      endOfCollectionElement.appendChild(title);
    }

    endOfCollectionElement.hidden = false;
    if (endOfCollectionElement.parentNode !== originalGrid.parentNode) {
      originalGrid.parentNode.insertBefore(endOfCollectionElement, originalGrid.nextSibling);
    }
  }

  function hideEndOfCollectionHint() {
    endOfCollectionElement.hidden = true;
  }

  function isStillCurrent(token) {
    return token === activeLoadToken;
  }

  /*
   * Fetches every page of a collection in order, starting from
   * page 1 (unless isInitial, where page 1 is already server-
   * rendered and only pages 2+ need fetching). Checks the token
   * after every single await - the only points where a competing
   * switchToCollection call could have happened in the meantime.
   */
  async function loadCollectionFully(handle, token, options) {
    const isInitial = !!(options && options.isInitial);
    let page = isInitial ? 2 : 1;
    let renderedFirstPage = isInitial; // page 1 already on screen for the initial collection

    try {
      while (page <= MAX_PAGES_PER_COLLECTION) {
        const doc = await fetchCollectionPage(handle, page);
        if (!isStillCurrent(token)) return;

        if (!renderedFirstPage) {
          const titleEl = doc.querySelector(TITLE_SELECTOR);
          const titleText = titleEl ? getCleanTitle(titleEl) : handle;

          if (originalTitle) originalTitle.textContent = titleText;
          document.title = titleText;

          loadingStateElement.hidden = true;
        }

        const rawCards = getProductCardsFromDocument(doc);

        if (rawCards.length === 0) {
          if (!renderedFirstPage) {
            // A genuinely empty collection - nothing to show, but
            // still need to clear the loading state.
            loadingStateElement.hidden = true;
          }
          break;
        }

        let existingKeys = null;

        if (isInitial && page === 2) {
          // Only the initial collection's continuation needs this -
          // the theme's own native pagination might also be adding
          // products to the same, already-populated grid.
          existingKeys = new Set();
          Array.from(originalGrid.querySelectorAll(':scope > li.grid__item')).forEach(
            (card) => {
              const key = getProductCardKey(card);
              if (key) existingKeys.add(key);
            }
          );
        }

        let addedAny = false;

        rawCards.forEach((card) => {
          if (existingKeys) {
            const key = getProductCardKey(card);
            if (key && existingKeys.has(key)) return;
            if (key) existingKeys.add(key);
          }

          const imported = document.importNode(card, true);
          imported.classList.add('sv-card-fade-in');
          applyImageLoadingTreatment(imported);
          originalGrid.appendChild(imported);
          addedAny = true;
        });

        if (!isStillCurrent(token)) return;

        if (!renderedFirstPage) {
          renderedFirstPage = true;
        }

        if (!addedAny && existingKeys) {
          // Nothing new on this page for the initial collection
          // (native pagination beat us to it) - treat as done.
          break;
        }

        page++;

        if (page <= MAX_PAGES_PER_COLLECTION) {
          showLoadingFooter();
        }

        /*
         * Explicitly yields control back to the browser after every
         * single page, before starting the next fetch - this is
         * what keeps clicking a different category responsive even
         * while a very large collection (hundreds of products,
         * dozens of pages) is still loading in the background.
         * Without this, several fast or cached page responses could
         * otherwise process back-to-back with little genuine
         * opportunity for the browser to handle pending input.
         */
        await new Promise((resolve) => requestAnimationFrame(resolve));
        if (!isStillCurrent(token)) return;
      }
    } catch (error) {
      console.error('[single-view] Error loading', handle, error);
      if (!renderedFirstPage) loadingStateElement.hidden = true;
    } finally {
      if (isStillCurrent(token)) {
        hideLoadingFooter();
        showEndOfCollectionHint(handle);
      }
    }
  }


  /*
   * ============================================================
   * INITIALISE
   * ============================================================
   */

  async function initialise() {
    try {
      const titleOriginalParent = originalTitle ? originalTitle.parentElement : null;
      const gridOriginalParent = originalGrid.parentElement;

      const layoutWrapper = document.createElement('div');
      layoutWrapper.className = 'sv-layout';
      layoutWrapper.appendChild(sidebarElement);

      const content = document.createElement('div');
      content.id = 'sv-content';
      if (originalTitle) content.appendChild(originalTitle);
      content.appendChild(loadingStateElement);

      originalGrid.parentNode.insertBefore(layoutWrapper, originalGrid);
      content.appendChild(originalGrid);
      layoutWrapper.appendChild(content);

      /*
       * Both the title and the grid can leave their own original
       * wrapper behind, empty, but still taking up space through
       * its own padding/background styling - Dawn-based themes
       * often render the collection title and the product grid as
       * two ENTIRELY SEPARATE section wrappers (e.g. a "collection
       * banner" section and a separate "product grid" section with
       * its own dedicated padding container), so each one needs
       * its own walk-up-and-hide pass, not just the title's side.
       * Stops the moment an ancestor still has other real content,
       * or after a few levels, so this can never accidentally hide
       * something wanted or walk all the way up into the rest of
       * the page.
       */
      function collapseEmptyAncestors(startElement, maxLevels) {
        let node = startElement;
        let levels = 0;

        while (node && levels < maxLevels) {
          const hasVisibleChildren = Array.from(node.children).some(
            (child) => child.style.display !== 'none'
          );
          const hasText = node.textContent.trim() !== '';

          if (hasVisibleChildren || hasText) break; // real content left - stop here

          node.style.display = 'none';

          const nextNode = node.parentElement;

          if (!nextNode || nextNode === document.body) break;

          node = nextNode;
          levels++;
        }
      }

      const MAX_ANCESTOR_LEVELS = 5;

      if (titleOriginalParent) collapseEmptyAncestors(titleOriginalParent, MAX_ANCESTOR_LEVELS);
      if (gridOriginalParent) collapseEmptyAncestors(gridOriginalParent, MAX_ANCESTOR_LEVELS);

      /*
       * Directly targets the specific empty "product grid padding"
       * wrapper found via direct inspection - the ancestor walk
       * above wasn't reliably reaching it, likely because it sits
       * in a different position in the tree than assumed. Matches
       * on the class substring (not the full name), since the
       * numeric section ID prefix is specific to this store's
       * section instance and would differ elsewhere. Still only
       * hides it if it's genuinely empty, so this can't accidentally
       * affect some other element that happens to share this class
       * pattern for a legitimate reason.
       */
      document.querySelectorAll('[class*="__product-grid-padding"]').forEach((el) => {
        if (el.children.length === 0 && el.textContent.trim() === '') {
          el.style.display = 'none';
        }
      });

      document.documentElement.style.setProperty('--sv-accent-rgb', determineAccentRgb());

      // Apply the shimmer-while-loading treatment to whatever's
      // already server-rendered for the initial collection's page 1.
      Array.from(originalGrid.querySelectorAll(':scope > li.grid__item')).forEach((card) => {
        applyImageLoadingTreatment(card);
      });

      orderedHandles = await getOrderedCollectionHandles();

      const initialTitleText = originalTitle
        ? getCleanTitle(originalTitle)
        : humanizeHandle(initialHandle);

      orderedHandles.forEach((handle) => {
        addSidebarItem(handle, handle === initialHandle ? initialTitleText : null);
      });

      updateSidebarActiveState(initialHandle);

      updateStickyHeaderHeight();

      /*
       * Reveals the collection content now that the full layout is
       * genuinely ready - sidebar populated, correct item
       * highlighted, header offset measured. Paired with the CSS in
       * single-view-hide-until-ready.liquid, which hides #product-grid
       * and the title via opacity before this script even runs -
       * without that, the browser paints the theme's normal,
       * un-restructured collection page once before this script has
       * a chance to run at all (since it's deferred), then visibly
       * snaps into the sidebar layout a moment later. This is what
       * that snippet is waiting for.
       */
      document.documentElement.classList.add('sv-ready');

      /*
       * Some browsers (notably Safari/WebKit) don't finish computing
       * a position:sticky element's initial layout inside a flex
       * container until a genuine reflow happens - which is exactly
       * why scrolling "fixes" the phantom top gap. Toggling the
       * sidebar out of and back into normal flow forces that
       * recalculation to happen immediately instead of waiting for
       * the customer's first scroll.
       */
      requestAnimationFrame(() => {
        sidebarElement.style.position = 'static';
        void sidebarElement.offsetHeight; // force synchronous reflow
        sidebarElement.style.position = '';
      });

      // The initial collection's page 1 is already on screen - only
      // its remaining pages need fetching, same cancellable loop as
      // every other collection.
      const initialToken = activeLoadToken;
      loadCollectionFully(initialHandle, initialToken, { isInitial: true });

      console.log('[single-view] Ready.');
    } catch (error) {
      console.error('[single-view] Initialisation error:', error);
      // Never leave the page permanently invisible if something
      // failed partway through - a brief flash is far better than
      // a blank page.
      document.documentElement.classList.add('sv-ready');
    }
  }

  initialise();
})();